import { TCopyConfig } from '../../../interfaces';
import { AUTO_DISCOUNTS } from '../../autoDiscounts';

const ToggleAZCopy: DeepPartial<TCopyConfig> = {
  addVehicleAddons: [
    'towing_road_services',
    'temporary_ride',
    'side_hustle',
    'gap',
    'oem_parts',
    'new_car_replacement',
    'glass',
  ],
  autoAddons: {
    side_hustle: {
      title: 'Side Hustle - Auto',
    },
  },
  autoDiscounts: [
    AUTO_DISCOUNTS.distantStudent,
    AUTO_DISCOUNTS.goodStudent,
    AUTO_DISCOUNTS.homeowner,
    AUTO_DISCOUNTS.multiCar,
    AUTO_DISCOUNTS.multiPolicy,
    AUTO_DISCOUNTS.safeDriving,
    AUTO_DISCOUNTS.teenDriver,
  ],
  visibleCoverages: {
    protectionCoverages: [
      {
        label: 'Underinsured Motorist Bodily Injury',
        key: 'underinsured_motorist_bodily_injury_limit',
      },
      {
        label: 'Pet Passenger',
        key: 'pet_passenger',
      },
    ],
  },
  vehicleAddons: [
    {
      label: 'Towing & Road Services',
      key: 'towing_road_services',
    },
    {
      label: 'Temporary Ride Coverage',
      key: 'temporary_ride',
    },
    {
      label: 'Side Hustle - Auto',
      key: 'side_hustle',
    },
    {
      label: 'Gap Coverage',
      key: 'gap',
    },
    {
      label: 'Original Parts Replacement',
      key: 'oem_parts',
    },
    {
      label: 'New Car Replacement',
      key: 'new_car_replacement',
    },
    {
      label: 'Glass & Safety',
      key: 'glass',
    },
  ],
  initialCoverageValues: {
    gap: 'false',
    temporary_ride: 'null',
    side_hustle: 'false',
    glass: 'false',
  },
};
export default ToggleAZCopy;
